import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import { dealApi } from '../features/deals/dealsApi';
import { alertsApi } from '../features/alerts/alertsApi';
import { notificationsApi } from '../features/notifications/notificationsApi';
import { profileApi } from '../features/profile/profileApi';
import { searchApi } from '../features/search/searchApi';
import { adminApi } from '../services/adminApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [dealApi.reducerPath]: dealApi.reducer,
    [alertsApi.reducerPath]: alertsApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [profileApi.reducerPath]: profileApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      dealApi.middleware,
      alertsApi.middleware,
      notificationsApi.middleware,
      profileApi.middleware,
      searchApi.middleware,
      adminApi.middleware,
    ),
});
